import { injectCmpFooterPrivacyLink } from '@s1/core/cmp-footer';
import {
  Form,
  Navigation,
  Search,
  TableOfContents,
  PricingSlider,
  HomepageAnimation
} from './components';

document.addEventListener('DOMContentLoaded', () => {
  // Initialize navigation.
  const navElement = document.querySelectorAll('.nav--footer, .nav--primary');
  if (navElement.length > 0) {
    Navigation();
  }

  // Initialize search.
  const searchElement = document.querySelector('.search');
  if (searchElement) {
    new Search(searchElement);
  }

  // Initialize table of contents.
  const tocElement = document.querySelector('.toc');
  if (tocElement) {
    new TableOfContents(tocElement);
  }

  // Initialize form.
  const formElement = document.querySelector('.fsForm');
  if (formElement) {
    new Form(formElement);
  }

  // Initialize pricing slider.
  const sliderWrappers = document.querySelectorAll('.pricing-slider');
  if (sliderWrappers.length > 0) {
    sliderWrappers.forEach((slider) => new PricingSlider(slider));
  }

  // Initialize animation.
  const homepageHeroElement = document.querySelector('.home .hero');
  if (homepageHeroElement) {
    new HomepageAnimation(homepageHeroElement);
  }

  // Inject CMP link for OneTrust
  injectCmpFooterPrivacyLink();
});
